export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo13-b4b9a68a7efa6bbfa6cba6e30beff9ca.jpg";